import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://qlvyesmhtolzhswkicbi.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFsdnllc21odG9semhzd2tpY2JpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQwODE4NzYsImV4cCI6MjA3OTY1Nzg3Nn0.PfMumN4KGc0pq0GHN08NE7YnoWNixkfW6L4YaK3RFPY';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);